<template>
  <b-form>
    <b-form-group :horizontal=horizontal>
      <b-form-input placeholder="Name oder Stadt der Schule" v-model="q" autocomplete="off"></b-form-input>
    </b-form-group>

    <b-form-group :horizontal=horizontal>
      <b-form-select v-model="selected" :options="options" :select-size="4" />
    </b-form-group>
  </b-form>
</template>
<script>
import {School} from '@/models'

export default {
  name: 'FindSchool',
  props: ['country', 'horizontal'],

  data: function () {
    return {
      q: '',
      current: '',
      selected: null,
      schools: []
    }
  },

  computed: {
    options: function () {
      return this.schools.map((school) => { return {value: school.id, text: school.name} })
    }
  },

  watch: {
    q: function (value) {
      let trimmed = value.trim()

      if (trimmed.length < 3) {
        return
      }

      if (trimmed !== this.current) {
        this.selected = null
        this.current = trimmed
        this.query(this.current)
      }
    },

    selected: function (id) {
      this.$emit('selected', this.schools.find(school => school.id === id))
    }
  },

  methods: {
    query: function (q) {
      this.schools = []
      this.axios.get('/schools', {params: {q: q, country: this.country}})
        .catch(e => this.$eventHub.$emit('error', e))
        .then((rsp) => {
          rsp.data.schools.forEach((row) => this.schools.push(new School(row.school)))
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schools/FindSchool.vue